import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "CFDI",
    items: [
      { label: "Facturas",           icon: "fas fa-file-invoice-dollar", href: "/ListadoFacturas",           key: "fiscal.facturas.ver"       },
      { label: "Complementos Pago",  icon: "fas fa-money-bill-wave",     href: "/ListadoComplementosPago",   key: "fiscal.complementos.ver"      },
      { label: "Pagos a Facturas",   icon: "fas fa-hand-holding-usd",    href: "/ListadoPagosFacturas",      key: "fiscal.pagosFacturas.ver"      },
      { label: "Notas de Crédito",   icon: "fas fa-money-check-alt",     href: "/ListadoNotasCredito",       key: "fiscal.notasCredito.ver"   },
      { label: "Devoluciones",       icon: "fas fa-undo-alt",            href: "/ListadoDevolucionesFiscal", key: "fiscal.devoluciones.ver"   },
    ],
  },
  {
    title: "Cobranza",
    items: [
      { label: "Abonos a Facturas",  icon: "fas fa-donate",     href: "/ListadoAbonosFacturas", key: "fiscal.abonosFacturas.ver" },
      { label: "Estado de Cuenta",   icon: "fas fa-file-alt",   href: "/EstadoCuentaK",         key: "fiscal.estadoCuenta.ver" },
    ],
  },
  {
    title: "Configuración",
    items: [
      { label: "Registrar FIEL",     icon: "fas fa-file-alt",   href: "/RegistrarEmpresas", key: "fiscal.fiel.ver" },
    ],
  },
];

function BotonesFiscal() {
  return (
    <MenuGrid
      title="Fiscal"
      subtitle="Facturación electrónica (CFDI): facturas, complementos, notas y devoluciones"
      icon="fas fa-file-invoice"
      accent={{ color: "#0d9488", bg: "#f0fdfa" }}
      modulo="fiscal"
      sections={SECTIONS}
    />
  );
}

export default BotonesFiscal;
